package com.daytimegaming.ourdailyfinances.domain.usecase

import com.daytimegaming.ourdailyfinances.domain.Response
import com.daytimegaming.ourdailyfinances.domain.model.RealEstateHolding
import com.daytimegaming.ourdailyfinances.domain.repository.RealEstateRepository
import kotlinx.coroutines.flow.Flow

class CreateRealEstateHolding(private val repo: RealEstateRepository) {
    suspend operator fun invoke(
        nickname: String,
        addressLine1: String,
        addressLine2: String?,
        city: String,
        state: String,
        zipCode: String,
        county: String?,
        purchasePrice: Double,
        mortgageAmount: Double?,
        mortgageInterestRate: Double?
    ): Response<RealEstateHolding> = repo.createRealEstateHolding(
        nickname, addressLine1, addressLine2, city, state, zipCode, county, purchasePrice, mortgageAmount, mortgageInterestRate
    )
}

class GetRealEstateHoldings(private val repo: RealEstateRepository) {
    operator fun invoke(): Flow<Response<List<RealEstateHolding>>> = repo.getRealEstateHoldings()
}

class GetRealEstateHolding(private val repo: RealEstateRepository) {
    operator fun invoke(realEstateHoldingId: String): Flow<Response<RealEstateHolding>> =
        repo.getRealEstateHolding(realEstateHoldingId)
}

class UpdateRealEstateHolding(private val repo: RealEstateRepository) {
    suspend operator fun invoke(
        realEstateHoldingId: String,
        nickname: String?,
        addressLine1: String?,
        addressLine2: String?,
        city: String?,
        state: String?,
        zipCode: String?,
        county: String?,
        purchasePrice: Double?,
        mortgageAmount: Double?,
        mortgageInterestRate: Double?
    ): Response<RealEstateHolding> = repo.updateRealEstateHolding(
        realEstateHoldingId, nickname, addressLine1, addressLine2, city, state, zipCode, county, purchasePrice, mortgageAmount, mortgageInterestRate
    )
}

class DeleteRealEstateHolding(private val repo: RealEstateRepository) {
    suspend operator fun invoke(realEstateHoldingId: String): Response<Unit> =
        repo.deleteRealEstateHolding(realEstateHoldingId)
}

class RefreshRealEstateValueEstimate(private val repo: RealEstateRepository) {
    suspend operator fun invoke(realEstateHoldingId: String): Response<RealEstateHolding> =
        repo.refreshValueEstimate(realEstateHoldingId)
}

class RealEstateUseCase(
    val CreateRealEstateHolding: CreateRealEstateHolding,
    val GetRealEstateHoldings: GetRealEstateHoldings,
    val GetRealEstateHolding: GetRealEstateHolding,
    val UpdateRealEstateHolding: UpdateRealEstateHolding,
    val DeleteRealEstateHolding: DeleteRealEstateHolding,
    val RefreshRealEstateValueEstimate: RefreshRealEstateValueEstimate,
)
